import { Button, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { CompanySelector } from '../../components/CompanySelector';
import { EmptyState } from '../../components/EmptyState';
import { ErrorNotice } from '../../components/ErrorNotice';
import { PageHeader } from '../../components/PageHeader';
import { useSelectedCompany } from '../../components/useSelectedCompany';
import { useLanguage } from '../../i18n/LanguageContext';

import { ShopOrdersTable } from './ShopOrdersTable';

/** Objednávky (R0034): the orders of every linked shop of a company, each saying which shop it came from. */
export const OrdersPage = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const selection = useSelectedCompany('orders.read');
  const company = selection.company;

  if (!selection.isLoading && company === null) {
    return (
      <>
        <PageHeader title={t('orders.title')} />
        <ErrorNotice error={selection.error} onRetry={selection.retry} />
        <Paper variant="outlined">
          <EmptyState
            title={t('products.noCompany')}
            detail={t('orders.noCompanyDetail')}
            action={<Button onClick={() => navigate('/companies')}>{t('nav.companies')}</Button>}
          />
        </Paper>
      </>
    );
  }

  return (
    <>
      <PageHeader
        title={t('orders.title')}
        subtitle={t('orders.subtitle')}
        action={
          <CompanySelector
            companies={selection.companies}
            value={company}
            onChange={(companyId) => selection.select(companyId)}
          />
        }
      />
      <ErrorNotice error={selection.error} onRetry={selection.retry} />
      {company !== null ? <ShopOrdersTable key={company.id} companyId={company.id} /> : null}
    </>
  );
};
